import { render, staticRenderFns } from "./imageDetailModal.vue?vue&type=template&id=3618cb60&"
import script from "./imageDetailModal.vue?vue&type=script&lang=ts&"
export * from "./imageDetailModal.vue?vue&type=script&lang=ts&"
import style0 from "./imageDetailModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports